import { NgModule } from '@angular/core';
import { HttpModule } from '../public_api';

@NgModule({
  imports: [HttpModule],
})
export class WorkOrderRepositoryModule {}
